import {Grid} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'

import {useConfigContext} from '../../../contexts'
import {renderWidget} from '../../index'
import type {SectionProps as Props} from '../../types'
import * as classes from './VerticalsSection@mobile.classes'

export function VerticalsSection({section}: Props): ReactElement {
  const i18n = useI18n()
  const {experiments3} = useConfigContext()

  // TODO: Выпилить условие после переезда на вертикали из ручки формы
  return !!experiments3.bdui_use_b2b_external_order_mode?.enabled ? (
    <>
      <Grid xs={12} item>
        <div className={classes.wrapper.formTitle}>
          <span className={classes.formTitle}>{i18n('order.form.verticals.title', 'Новый заказ')}</span>
        </div>
      </Grid>
      {section.widgets.map(renderWidget)}
    </>
  ) : (
    <>
      {section.widgets.flatMap(widget => {
        return !['vertical_group_id_wide_segment_widget', 'cargo_c2c_order_forms_b2b_lk_verticals_widget'].includes(
          widget.widget_id,
        )
          ? renderWidget(widget)
          : []
      })}
    </>
  )
}
